/**
 * Load Script
 *
 * Load script for the theme.
 *
 * @package		Pompano Pickle
 * @subpackage	Theme Scripts
 *
 * @since	1.0.0
 */

/*! Pompano Pickle Load Script * Copyright (c) 2026 Robert Noakes * License: GNU General Public License v2 or later */

if (window.popi_l10n)
{
	var popi_link = document.createElement('link');

	popi_link.setAttribute('rel', 'stylesheet');
	popi_link.setAttribute('type', 'text/css');
	
	document.head.appendChild(popi_link);
	
	popi_link.setAttribute('href', window.popi_l10n.assets.css);

	var popi_script = document.createElement('script');

	document.head.appendChild(popi_script);
	
	popi_script.setAttribute('src', window.popi_l10n.assets.js);
}